document.addEventListener('DOMContentLoaded', function() {
    const form = document.querySelector('form[data-type="add-to-cart-form"]');
    const greetingInput = document.querySelector('[data-greeting-card-input]');
    const greetingProp = document.querySelector('[data-greeting-card-prop]');

    if (form && greetingInput && greetingProp) {
        // Remove disabled attribute immediately
        greetingProp.removeAttribute('disabled');
        
        form.addEventListener('submit', function(e) {
            e.preventDefault(); // Prevent form submission temporarily

            if (!greetingInput.value.trim()) {
                alert('Please enter a greeting card message');
                return;
            }

            // Set the value and ensure it's not disabled
            greetingProp.value = greetingInput.value.trim();
            greetingProp.removeAttribute('disabled');

            // Continue with form submission
            form.submit();
        });
    }
});


